import { addDaysToKey } from "../../utils/manilaTime";

// All client visit queries share this prefix so one invalidation refreshes them.
export const CLIENT_VISIT_KEY = "me:clientVisits";
export const CLIENT_VISIT_OPTIONS_KEY = "me:clientVisitOptions";

export const MAX_CLIENTS = 20;
export const MAX_PURPOSE = 500;

export const CLIENT_VISIT_STATUS = {
  PENDING: { label: "Waiting for approval", tone: "amber" },
  APPROVED: { label: "Approved", tone: "green" },
  REJECTED: { label: "Rejected", tone: "red" },
  CANCELLED: { label: "Cancelled", tone: "gray" },
};

export const STATUS_TABS = [
  { id: "", label: "All" },
  { id: "PENDING", label: "Pending" },
  { id: "APPROVED", label: "Approved" },
  { id: "REJECTED", label: "Rejected" },
  { id: "CANCELLED", label: "Cancelled" },
];

// A pending request whose date has arrived can no longer be approved.
export const visitStatusOf = (visit) =>
  visit.expired
    ? { label: "Not approved in time", tone: "gray" }
    : (CLIENT_VISIT_STATUS[visit.status] ?? {
        label: visit.status,
        tone: "gray",
      });

export const firstFileableDate = (todayKey) => addDaysToKey(todayKey, 1);

// Returns an error message, or "" when the form can be sent.
export const validateVisit = ({ date, clientIds, purpose }, todayKey) => {
  if (!date) return "Choose the date of the visit.";
  if (date <= todayKey) return "The date must be after today.";
  if (!clientIds.length) return "Choose at least one client.";
  if (clientIds.length > MAX_CLIENTS)
    return `Choose at most ${MAX_CLIENTS} clients.`;
  if (!purpose.trim()) return "Please give the purpose of the visit.";
  return "";
};

// Clients with no saved location: check-ins there are only flagged for review.
export const clientsWithoutLocation = (clients = []) =>
  clients.filter((c) => !c.hasLocation);

export const NO_LOCATION_TEXT =
  "has no saved location, so check-ins there are flagged for review.";
